"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncorrectSyntaxError = void 0;
class IncorrectSyntaxError extends Error {
    constructor(message, exp) {
        super(message);
        this.name = "IncorrectSyntaxError";
        this.data = { exp };
    }
    getData() {
        return this.data;
    }
}
exports.IncorrectSyntaxError = IncorrectSyntaxError;
